module.exports = __webpack_public_path__ + "static/media/Leshrac.785c7e6a.png";